webpackJsonp([188429276130593],{

/***/ 211:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(33);
	
	var _contentPage = __webpack_require__(4);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(5);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFacebookPixel = __webpack_require__(22);
	
	var _reactFacebookPixel2 = _interopRequireDefault(_reactFacebookPixel);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Modal = __webpack_require__(9);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	__webpack_require__(29);
	
	__webpack_require__(28);
	
	var _reactLinkedinInsight = __webpack_require__(31);
	
	var _reactLinkedinInsight2 = _interopRequireDefault(_reactLinkedinInsight);
	
	__webpack_require__(58);
	
	__webpack_require__(92);
	
	__webpack_require__(211);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var icon1 = "https://winpeforum.com/assets/elements/AchithaJacob.png";
	var icon2 = "https://winpeforum.com/assets/elements/AnjaIiSosale.jpg";
	var icon3 = "https://winpeforum.com/assets/elements/NruthyaMadappa.jpg";
	var icon4 = "https://winpeforum.com/assets/elements/KanikaMayar.jpeg";
	
	var duration = 400;
	
	var TeamModal = function TeamModal(_ref) {
	  var activeItem = _ref.activeItem,
	      show = _ref.show,
	      onHide = _ref.onHide;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      direction: "",
	      className: "teamdetails__wrapper",
	      show: show,
	      onHide: onHide
	    },
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "head_section" },
	        _react2.default.createElement(
	          "span",
	          { className: "item_name" },
	          activeItem.name
	        ),
	        _react2.default.createElement("div", {
	          className: "item_des",
	          dangerouslySetInnerHTML: { __html: activeItem.post }
	        })
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "cross pull-right" },
	        _react2.default.createElement("i", { onClick: onHide, className: "fa fa-times" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "item__desc" },
	        _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: activeItem.desc } })
	      )
	    ),
	    _react2.default.createElement(_Modal2.default.Footer, null)
	  );
	};
	
	TeamModal.propTypes = {
	  activeItem: _propTypes2.default.object,
	  show: _propTypes2.default.object,
	  onHide: _propTypes2.default.object
	};
	
	var WinPEEdge = function (_Component) {
	  _inherits(WinPEEdge, _Component);
	
	  // constructor() {
	  //   super();
	  //   this.state = {
	  //     isShow: false,
	  //     activeItem: {},
	  //   };
	  // }
	
	  // togglePopUp = (item) => {
	  //   this.setState({
	  //     isShow: !this.state.isShow,
	  //     activeItem: item || {},
	  //   });
	  // };
	  function WinPEEdge(args) {
	    _classCallCheck(this, WinPEEdge);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, args));
	
	    _this.updateWindowDimensions = function () {
	      var slidesToShow = _this.state.slidesToShow;
	      // // console.log("width", window.innerWidth)
	
	      if (window.innerWidth <= 768 && window.innerWidth > 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else if (window.innerWidth <= 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      }
	    };
	
	    _this.togglePopUp = function (item) {
	      _this.setState({
	        isShow: !_this.state.isShow,
	        activeItem: item || {}
	      });
	    };
	
	    _this.state = {
	      slidesToShow: 1,
	      activeItem: {},
	      isShow: false,
	      defaultStyle: {
	        transition: "opacity " + duration + "ms ease-in-out",
	        opacity: 0
	      }
	    };
	
	    _this.Speaker2 = [{
	      imgUrl: icon1,
	      desc: "<div>\n        Achitha Jacob is the CEO and Founder at Proactive For Her. Achitha dropped out of Harvard Business School to build Proactive For Her. She has previously worked with Fortune 500 healthcare and management consulting, after graduating from IIT Bombay.\n\n\n\t\t</div>",
	      name: "Achitha Jacob",
	      post: "<div>CEO & Founder<br/> Proactive For Her\n        </div>"
	    }, {
	      imgUrl: icon2,
	      desc: "<div>\n        AnjaIi Sosale is a Partner at WaterBridge Ventures, an early stage, India focused, Seed to Series A fund, that invests between $250k and $2.5m first cheques into tech-startups. Anjali focuses on consumer tech and is based in Bangalore. Anjali has over 15 years of experience in various parts of the investment eco-system advising companies on their capital agenda. She started her career in investment banking, with EY in 2006 where she spent a decade across multiple geographies and deal advisory domains from due diligence to cross-border M&A and private equity. Initially (2009-14) fundraising for growth stage education, retail and consumer companies before the internet economy boom led her to focus (from 2015 onwards) on the burgeoning start-up eco-system driving consumer tech and e-commerce in India.<br/><Br/>\n\n        She was instrumental in setting up the early stage, start-up focused practice in 2014 which she led until she left in 2017 to join Myntra (A Flipkart and Walmart Group Company and India's largest fashion e- commerce company). At Myntra, Anja Iiwas head of the Brand Accelerator Program, that sought out minority equity partnerships to jointly scale the next generation of D2C fashion and lifestyle brands in India.\n        <br/><Br/>\n        She took the program from idea and concept to scale, creating the first generation of D2C brands in India, diversifying the portfolio of 16 across lifestyle categories, introducing and expanding it into Flipkart. These brands collectively earned over $100m in annual revenues for the FK Group making them a valuable part of the ecosystem and generating incredible value to its founders with brands blitz scaling to Rs 100 crs brands within 2 years\n        \n\t\t</div>",
	      name: "AnjaIi Sosale",
	      post: "<div>Partner<br/> WaterBridge Ventures\n\n\n        </div>"
	    }, {
	      imgUrl: icon4,
	      desc: "<div>\n        Kanika has 11 years of experience across venture capital and growth stage investing.  She joined Vertex in 2020 as part of the India investment team. At Vertex, Kanika has led investments into consumer, health, agri, B2B and other sectors where technology can play a pivotal role in scaling and achieving strong business economics. Prior to joining Vertex, Kanika was an Investment Officer with the International Finance Corporation (IFC) where she focused on investing in early-stage technology, telecom, renewable energy and infrastructure companies across India and South Asia. Before IFC, Kanika was with Goldman Sachs\u2019s Investment Banking team covering transactions in natural resources in Europe.<br/><br/>\n\nKanika holds a Bachelor in Economics from the Lady Shri Ram College, Delhi University and an MBA from the Indian Institute of Management, Ahmedabad.\n\n \n        \n\n\t\t</div>",
	      name: "Kanika Mayar",
	      post: "<div>Partner<br/>Vertex Ventures\n\n\n        </div>"
	    }, {
	      imgUrl: icon3,
	      desc: "<div>\n        Nruthya Madappa is the Head of Growth and Capital Development at 3one4 Capital. In addition to supporting investments, topline and capital growth for the portfolio at the firm, Nruthya works closely with global institutional and strategic investors to drive the growth of our portfolio companies. Her team partners deeply with the latter in planning and achieving financial and strategic objectives including capital raises, revenue acceleration, M&A, and exits. \n        <br/><Br/>\n        Over her career in the US and India, Nruthya has led global teams across technology, finance, real estate, education and economic policy. Before 3one4 Capital, Nruthya founded and led The CoWrks Foundry (a business accelerator for early stage companies) as Managing Partner, investing in over 25 companies and establishing global partnerships with Yale and Columbia University. <br/><Br/>\n        \n        Prior to The CoWrks Foundry she drove the Revenue and Growth orgs at Cuemath and spearheaded the 15M Series B from Capital G and Sequoia Capital for the edtech giant. Throughout her career, Nruthya has designed and scaled products, and raised capital for high growth companies - strengths she brings to bear for the 3one4 portfolio. <br/><Br/>\n        \n        Nruthya holds BS and MS degrees in Electrical Engineering from Stanford University and an MBA from Harvard Business School.\n        \n\n\t\t</div>",
	      name: "Nruthya Madappa",
	      post: "<div>Director<br/> 3one4 Capital \n\n\n        </div>"
	    }];
	
	    return _this;
	  }
	
	  WinPEEdge.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.updateWindowDimensions();
	    window.addEventListener("resize", this.updateWindowDimensions);
	    _reactFacebookPixel2.default.init("2879175222167037");
	    _reactFacebookPixel2.default.track("ViewContent", location);
	    _reactLinkedinInsight2.default.init("2117884");
	    _reactLinkedinInsight2.default.track("2310748");
	    setTimeout(function () {
	      _this2.setState({
	        defaultStyle: {
	          transition: "opacity " + duration + "ms ease-in-out",
	          opacity: 1
	        }
	      });
	    }, 500);
	  };
	
	  WinPEEdge.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener("resize", this.updateWindowDimensions);
	  };
	
	  WinPEEdge.prototype.render = function render() {
	    var _state = this.state,
	        defaultStyle = _state.defaultStyle,
	        isShow = _state.isShow,
	        slidesToShow = _state.slidesToShow;
	    var location = this.props.location;
	
	
	    console.log("render", this.render1, slidesToShow);
	    this.render1 = this.render1 + 1;
	
	    return _react2.default.createElement(
	      _contentPage2.default,
	      null,
	      _react2.default.createElement(_meta2.default, {
	        title: "SheShines with Winpe",
	        image: "https://winpeforum.com/assets/elements/sheshineswebpage1.png",
	        description: "Winpe's first in-person networking event for women in investing and entrepreneurship was welcomed with high enthusiasm and energy and demands for more such sessions!",
	        location: location
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "section__content", style: defaultStyle },
	        _react2.default.createElement(
	          "div",
	          { className: "toastshine_wrapper" },
	          _react2.default.createElement(
	            "div",
	            { className: "back_event" },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/events/" },
	              _react2.default.createElement(
	                "i",
	                { className: "fa fa-arrow-left" },
	                " Back to Events"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "toastshine_section" },
	            _react2.default.createElement(
	              "h1",
	              { className: "ignite-ask-me-anything__heading" },
	              "SheShines with Winpe "
	            ),
	            _react2.default.createElement("hr", { className: "ignite-ask-me-anything__hr" }),
	            _react2.default.createElement(
	              "div",
	              { className: "top_text" },
	              _react2.default.createElement(
	                "b",
	                null,
	                "she"
	              ),
	              "shines with Winpe are in-person networking sessions for women in the investing and entrepreneurship ecosystem.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "The importance of building strong networks cannot be underscored too much. The number of women in investing and entrepreneurship continues to be small and the imperative for everyone to know each other, support each other and leverage each other is that much stronger.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "Through these events, Winpe attempts to bring women together to meet old friends and make new ones.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "b",
	                null,
	                "she"
	              ),
	              "shines events include interactive, candid and close-range discussions with senior women leaders and women champions from various fields and of course, lots of networking.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "b",
	                null,
	                "she"
	              ),
	              "shines will be in Mumbai, Bangalore & Delhi/Gurgaon every quarter.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null)
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { className: "tab_section container", style: { textAlign: 'center' } },
	              _react2.default.createElement(
	                "ul",
	                { "class": "nav nav-tabs justify-content-center", role: "tablist", style: { display: "inline-block" } },
	                _react2.default.createElement(
	                  "li",
	                  { "class": "nav-item" },
	                  _react2.default.createElement(
	                    "a",
	                    { "class": "nav-link  ", "data-toggle": "tab", href: "#tabs-3", role: "tab", style: { padding: "10px 5px" } },
	                    _react2.default.createElement(
	                      "h4",
	                      { style: { fontSize: '17px' }, className: "ignite-ask-me-anything__heading" },
	                      " \xA0 Mumbai\xA0  "
	                    ),
	                    " "
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { "class": "nav-item" },
	                  _react2.default.createElement(
	                    "a",
	                    { "class": "nav-link  ", "data-toggle": "tab", href: "#tabs-1", role: "tab", style: { padding: "10px 5px" } },
	                    " ",
	                    _react2.default.createElement(
	                      "h4",
	                      { style: { fontSize: '17px' }, className: "ignite-ask-me-anything__heading" },
	                      " \xA0  Delhi\xA0   "
	                    ),
	                    " "
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { "class": "nav-item" },
	                  _react2.default.createElement(
	                    "a",
	                    { "class": "nav-link  active ", "data-toggle": "tab", href: "#tabs-2", role: "tab", style: { padding: "10px 5px" } },
	                    _react2.default.createElement(
	                      "h4",
	                      { style: { fontSize: '17px' }, className: "ignite-ask-me-anything__heading" },
	                      " \xA0  Bangalore\xA0   "
	                    ),
	                    " "
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "tab-content" },
	                _react2.default.createElement(
	                  "div",
	                  { "class": "tab-pane", id: "tabs-1", role: "tabpanel" },
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "eventlist_listing eventlist_listing_new" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12 col-sm-12 col-xs-12" },
	                        _react2.default.createElement("div", { className: "top_e_border" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_card" },
	                          _react2.default.createElement(
	                            "h3",
	                            null,
	                            "August 25, 2022 (5:00 PM - 8:00 PM IST)"
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            _react2.default.createElement(
	                              "h5",
	                              null,
	                              "Networking works "
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "h4",
	                            null,
	                            " ",
	                            _react2.default.createElement(
	                              "i",
	                              null,
	                              "Hotel Andaz, Aerocity - Delhi"
	                            )
	                          ),
	                          _react2.default.createElement("br", null),
	                          " ",
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "center",
	                            null,
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/SheShines25Aug2022/" },
	                              _react2.default.createElement(
	                                "button",
	                                { style: { backgroundColor: "#BF2026", border: "none", color: "#fff", padding: "5px 20px 5px 20px", fontSize: "20px", marginBottom: "10px" }, "class": "button" },
	                                " Event Report"
	                              ),
	                              " "
	                            ),
	                            " "
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement("hr", null),
	                          _react2.default.createElement("hr", null)
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "tab-pane active", id: "tabs-2", role: "tabpanel" },
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "eventlist_listing eventlist_listing_new" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12 col-sm-12 col-xs-12" },
	                        _react2.default.createElement("div", { className: "top_e_border" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_card" },
	                          _react2.default.createElement(
	                            "h3",
	                            null,
	                            "January 19, 2023 (4:00 PM - 7:00 PM IST)"
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            _react2.default.createElement(
	                              "h5",
	                              null,
	                              "Journeys: Women & Leadership"
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "h4",
	                            null,
	                            " ",
	                            _react2.default.createElement(
	                              "i",
	                              null,
	                              "Jook Taproom, Indiranagar, Bangalore"
	                            )
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "center",
	                            null,
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/SheShines19Jan2023/" },
	                              _react2.default.createElement(
	                                "button",
	                                { style: { backgroundColor: "#BF2026", border: "none", color: "#fff", padding: "5px 20px 5px 20px", fontSize: "20px", marginBottom: "10px" }, "class": "button" },
	                                " Event Report"
	                              ),
	                              " "
	                            ),
	                            " "
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("hr", null),
	                    _react2.default.createElement("hr", null)
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "eventlist_listing eventlist_listing_new" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12 col-sm-12 col-xs-12" },
	                        _react2.default.createElement("div", { className: "top_e_border" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_card" },
	                          _react2.default.createElement(
	                            "h3",
	                            null,
	                            "June 30, 2022 (5:00 PM - 8:00 PM IST)"
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            _react2.default.createElement(
	                              "h5",
	                              null,
	                              "Networking Works: Leveraging Networks for Growth and Success"
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "h4",
	                            null,
	                            " ",
	                            _react2.default.createElement(
	                              "i",
	                              null,
	                              "Kaz\xE9, Bangalore"
	                            )
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "center",
	                            null,
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/SheShines30June2022/" },
	                              _react2.default.createElement(
	                                "button",
	                                { style: { backgroundColor: "#BF2026", border: "none", color: "#fff", padding: "5px 20px 5px 20px", fontSize: "20px", marginBottom: "10px" }, "class": "button" },
	                                " Event Report"
	                              ),
	                              " "
	                            ),
	                            " "
	                          ),
	                          _react2.default.createElement("br", null)
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("hr", null),
	                    _react2.default.createElement("hr", null)
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { "class": "tab-pane  ", id: "tabs-3", role: "tabpanel" },
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "eventlist_listing eventlist_listing_new" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12 col-sm-12 col-xs-12" },
	                        _react2.default.createElement("div", { className: "top_e_border" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_card" },
	                          _react2.default.createElement(
	                            "h3",
	                            null,
	                            "November 10, 2022 (5:00 - 8:00 PM IST)"
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Journey's: Women & Leadership"
	                          ),
	                          _react2.default.createElement(
	                            "h4",
	                            null,
	                            " ",
	                            _react2.default.createElement(
	                              "i",
	                              null,
	                              "The Quorum Club, LowerParel, Mumbai"
	                            )
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "center",
	                            null,
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/SheShines10Nov2022/" },
	                              _react2.default.createElement(
	                                "button",
	                                { style: { backgroundColor: "#BF2026", border: "none", color: "#fff", padding: "5px 20px 5px 20px", fontSize: "20px", marginBottom: "10px" }, "class": "button" },
	                                " Event Report"
	                              ),
	                              " "
	                            ),
	                            " "
	                          ),
	                          _react2.default.createElement("br", null)
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("hr", null),
	                    _react2.default.createElement("hr", null),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12 col-sm-12 col-xs-12" },
	                        _react2.default.createElement("div", { className: "top_e_border" }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "list_card" },
	                          _react2.default.createElement(
	                            "h3",
	                            null,
	                            "April 21, 2022 (4:30 PM IST)"
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Networking works"
	                          ),
	                          _react2.default.createElement(
	                            "h4",
	                            null,
	                            " ",
	                            _react2.default.createElement(
	                              "i",
	                              null,
	                              "The Quorum Club, LowerParel, Mumbai"
	                            )
	                          ),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement("br", null),
	                          _react2.default.createElement(
	                            "center",
	                            null,
	                            _react2.default.createElement(
	                              "a",
	                              { href: "/SheShinesWithWinPE/" },
	                              _react2.default.createElement(
	                                "button",
	                                { style: { backgroundColor: "#BF2026", border: "none", color: "#fff", padding: "5px 20px 5px 20px", fontSize: "20px", marginBottom: "10px" }, "class": "button" },
	                                " Event Report"
	                              ),
	                              " "
	                            ),
	                            " "
	                          ),
	                          _react2.default.createElement("br", null)
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("hr", null),
	                    _react2.default.createElement("hr", null)
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null)
	          ),
	          _react2.default.createElement(TeamModal, {
	            show: isShow,
	            onHide: this.togglePopUp,
	            activeItem: this.state.activeItem
	          })
	        )
	      )
	    );
	  };
	
	  return WinPEEdge;
	}(_react.Component);
	
	WinPEEdge.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = WinPEEdge;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-she-shines-index-js-ef8f0a910e3713a41daa.js